import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { PageNotFoundComponent } from './auth/page-not-found/page-not-found.component';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
// import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';

const routes: Routes = [{ path: '**', component: PageNotFoundComponent }];

@NgModule({
  imports: [
    /**
     * Temporary disable until angular v20 support is added
     * See: https://github.com/mgechev/ngx-quicklink/issues/172
     */
    // QuicklinkModule,
    RouterModule.forRoot(routes,
      {
        useHash: true,
        // preloadingStrategy: QuicklinkStrategy,
      }
    ),
  ],
  declarations: [],
  exports: [RouterModule],
})
export class AppRoutingModule { }
